import { Injectable, Service, inject } from '@angular/core';
import { BreakpointObserver } from '@angular/cdk/layout';
import { BehaviorSubject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

const BREAKPOINT_MAP: { [key: string]: string } = {
  '(max-width: 575.98px)': 'bs-xs',
  '(min-width: 576px) and (max-width: 767.98px)': 'bs-sm',
  '(min-width: 768px) and (max-width: 991.98px)': 'bs-md',
  '(min-width: 992px) and (max-width: 1199.98px)': 'bs-lg',
  '(min-width: 1200px)': 'bs-xl'
};

const MEDIA_QUERIES = Object.keys(BREAKPOINT_MAP);

@Service()
export class CoreMediaService {
  private _breakpointObserver = inject(BreakpointObserver);

  currentMediaQuery: string;
  onMediaUpdate: BehaviorSubject<string> = new BehaviorSubject<string>('');

  constructor() {
    this.currentMediaQuery = '';
    this._init();
  }

  private _init(): void {
    this._breakpointObserver
      .observe(MEDIA_QUERIES)
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe(result => {
        for (const query of MEDIA_QUERIES) {
          if (result.breakpoints[query]) {
            const alias = BREAKPOINT_MAP[query];
            if (this.currentMediaQuery !== alias) {
              this.currentMediaQuery = alias;
              this.onMediaUpdate.next(alias);
            }
            break;
          }
        }
      });
  }
}
